import SignalThresholdPlot from "../../d3/signal/SignalThresholdPlot.svelte";
import { okhsl } from "../../../d3-mapp/color/index.js";
import { DataSet } from "../../d3/legacy/sensor/dataset.js";
import { legacyColorToColor } from "./sensor-export-helpers.js";
export const getSelectedFeedIds = (selectedFeed, sensorFeedMap, feedName, feedId) => {
    if (sensorFeedMap) {
        let sensorFeeds = Object.values(sensorFeedMap);
        if (feedId) {
            sensorFeeds = sensorFeeds.filter((sensorFeed) => sensorFeed.id === feedId);
        }
        else if (feedName) {
            sensorFeeds = sensorFeeds.filter((sensorFeed) => sensorFeed.properties.name === feedName);
        }
        else if (selectedFeed !== "__all__") {
            sensorFeeds = sensorFeeds.filter((sensorFeed) => sensorFeed.id === selectedFeed);
        }
        return sensorFeeds.map((sensorFeed) => sensorFeed.id);
    }
    return [];
};
export const processSensorData = (feedPatterns, sensorData, 
//  range: TemporalRange,
signalPlotConfigurations, sensorFeedProbes, plotDefinitionsMap, percentile) => {
    if (feedPatterns.length > 0 && sensorData) {
        Object.keys(sensorData.feedIdPatternMap).forEach((feedPattern) => {
            const feedIds = sensorData.feedIdPatternMap[feedPattern];
            if (feedIds && feedIds.length > 0) {
                const _feedId = feedIds[0];
                addFeedPlots(_feedId, sensorData, 
                //          range,
                signalPlotConfigurations, sensorFeedProbes, plotDefinitionsMap, percentile);
            }
        });
    }
};
//the workhorse creating the probe plot definitions & configurations for given feedId
const addFeedPlots = (feedId, sensorData, 
//  range: TemporalRange,
signalPlotConfigurations, sensorFeedProbes, plotDefinitionsMap, percentile) => {
    const buildSignalPlotConfigurations = signalPlotConfigurations.length === 0;
    //console.log("sensorFeedProbes", sensorFeedProbes);
    const dataSetIds = sensorData.feedIdDataSetMap[feedId];
    //console.log("dataSetIds", dataSetIds);
    const probeDataSetMap = sensorData.feedIdProbeDataSetMap[feedId];
    //console.log("probeDataSetMap", JSON.stringify(probeDataSetMap, undefined, 2));
    plotDefinitionsMap[feedId] = [];
    const plotDefinitions = plotDefinitionsMap[feedId];
    const feedSignals = getFeedSignals(feedId, sensorData, sensorFeedProbes);
    Object.keys(feedSignals).forEach((feedProbeId) => {
        const dataSetSignal = feedSignals[feedProbeId];
        if (dataSetSignal) {
            const defaultProbeDefinition = sensorFeedProbes[feedProbeId];
            //      console.log('defaultProbeDefinition',defaultProbeDefinition);
            //const color = d3.hsl(defaultProbeDefinition.staticColor);
            const color = typeof defaultProbeDefinition.staticColor === 'string'
                ? okhsl(defaultProbeDefinition.staticColor)
                : okhsl(legacyColorToColor(defaultProbeDefinition.staticColor));
            color.opacity = 1;
            const title = `${defaultProbeDefinition.description}`;
            const yAxisLabel = `${defaultProbeDefinition.title} (${dataSetSignal.symbol()})`;
            plotDefinitions.push(createDefinition(title, yAxisLabel, color, defaultProbeDefinition.monitoringThreshold, percentile, dataSetSignal));
            if (buildSignalPlotConfigurations) {
                signalPlotConfigurations.push({
                    title: title,
                    color: color,
                    noThreshold: defaultProbeDefinition.monitoringThreshold == undefined,
                    use: true,
                    showThreshold: true,
                    showProjection: true,
                    showHistogram: true,
                });
            }
        }
    });
};
const getFeedSignals = (feedId, sensorData, sensorFeedProbes) => {
    const feedProbeSignals = Object.keys(sensorData.feedIdProbeDataSetMap[feedId]).reduce((signals, feedProbeId) => {
        signals[feedProbeId] = sensorData.feedIdProbeDataSetMap[feedId][feedProbeId]
            .map((dataSetId) => getSignal(feedProbeId, dataSetId, sensorData, sensorFeedProbes))
            .filter((signal) => signal != undefined);
        return signals;
    }, {});
    return Object.keys(feedProbeSignals).reduce((feedSignals, probeId) => {
        if (feedProbeSignals[probeId] && feedProbeSignals[probeId].length > 0) {
            const main = feedProbeSignals[probeId][0].signal;
            const alternatives = feedProbeSignals[probeId]
                .map((probeSignal) => probeSignal.signal)
                .slice(1);
            main.setAlternatives(alternatives);
            feedSignals[probeId] = main;
        }
        return feedSignals;
    }, {});
};
const getSignal = (feedProbeId, dataSetId, sensorData, sensorFeedProbes) => {
    const dataSetDef = sensorData.dataSets[dataSetId];
    if (dataSetDef && dataSetDef.data && dataSetDef.data.length > 0) {
        const dataSet = DataSet.get(dataSetDef);
        const probeIndex = dataSet.probeIndex(feedProbeId);
        if (probeIndex !== undefined) {
            const defaultProbeDefinition = sensorFeedProbes[feedProbeId];
            let targetUnit = defaultProbeDefinition.isqUnit;
            let unitSymbol = defaultProbeDefinition.isqUnit.getSymbol();
            const signal = dataSet.signal(probeIndex, targetUnit);
            return { signal, unitSymbol };
        }
    }
    return undefined;
};
const createDefinition = (title, yAxisLabel, color, threshold, percentile, signal) => {
    const thresholdColor = color.brighter();
    const undefinedColor = okhsl(`hsl(${color.h},50,30)`);
    thresholdColor.opacity = 1.0;
    let plotDefinition = {
        type: SignalThresholdPlot,
        properties: {
            signals: [signal],
            splineLabels: [title],
            tags: threshold != undefined
                ? [
                    {
                        value: threshold,
                        stroke: [{ color: thresholdColor, width: 2 }],
                    },
                ]
                : undefined,
            percentile,
            title,
            yAxisLabel,
            colors: [color],
            undefinedColors: [undefinedColor],
            scalarEther: false,
            showAxis: true,
            showThreshold: threshold != undefined,
            showProjection: threshold != undefined,
            showHistogram: threshold != undefined,
        },
    };
    // if (threshold != undefined) {
    //   console.log("plotDefinition with thresholds", plotDefinition);
    // }
    return plotDefinition;
};
